[
  {
    "code": "CZ-PR",
    "name": "Hlavní město Praha"
  },
  {
    "code": "CZ-JM",
    "name": "Jihomoravský kraj"
  },
  {
    "code": "CZ-JC",
    "name": "Jihočeský kraj"
  },
  {
    "code": "CZ-KA",
    "name": "Karlovarský kraj"
  },
  {
    "code": "CZ-VY",
    "name": "Kraj Vysočina"
  },
  {
    "code": "CZ-KR",
    "name": "Královéhradecký kraj"
  },
  {
    "code": "CZ-LI",
    "name": "Liberecký kraj"
  },
  {
    "code": "CZ-MO",
    "name": "Moravskoslezský kraj"
  },
  {
    "code": "CZ-OL",
    "name": "Olomoucký kraj"
  },
  {
    "code": "CZ-PA",
    "name": "Pardubický kraj"
  },
  {
    "code": "CZ-PL",
    "name": "Plzeňský kraj"
  },
  {
    "code": "CZ-ST",
    "name": "Středočeský kraj"
  },
  {
    "code": "CZ-ZL",
    "name": "Zlínský kraj"
  },
  {
    "code": "CZ-US",
    "name": "Ústecký kraj"
  }
]